import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PackageCostService', PackageCostService);

  PackageCostService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function PackageCostService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'packages';

    var service = {
      searchPackageCosts: searchPackageCosts,
      savePackageCosts: savePackageCosts,
    };

    return service;

    ////////////////

    function searchPackageCosts(pack, filterCriteria) {
      var url = apiUrl + '/' + pack.id + '/package_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = pack.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePackageCosts(pack, params, editMode) {
      var url = apiUrl + '/' + pack.id + '/package_costs';

      params.company_id = pack.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'COSTS_ADDED' : 'UPDATED_COSTS';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
